import Api from "../services/Api";



export const joinUserToCompany = async (userData) => {

    var res = {
      status: null
    }

    try {
      const response = await Api.post('/company/manage/joinUser', userData);

      // console.log('response.results', response);
      res.status = "valid";

      res = {...res,...response};

      // console.log(res);

      return res;

    } catch (error) {

      res.status = "error";
      var errorData = error.response.data; 
      res = {...res,...errorData};
      return res;
    }
};